import React from 'react';
import { TimerIcon } from 'lucide-react';
import { Container } from './Container';
import { CountdownUnits } from './CountdownUnits';
import { CTAButton } from './CTAButton';
import { Doodle } from './Doodle';
import { ProductMockup } from './ProductMockup';
import { finalSummary } from '../data/landing';
import { salesProof } from '../data/salesProof';
import { usePricing } from '../hooks/usePricing';
export function FinalCTA() {
  const {
    countdown,
    launchActive,
    price,
    regularPrice
  } = usePricing();
  const trust = ['Pago 100% seguro', 'Acceso inmediato', 'Garantía 7 días', ...salesProof.paymentMethods];
  return <section id="compra-final" aria-labelledby="final-title" className="relative overflow-hidden bg-teal-dark py-16 text-white sm:py-20 lg:py-24" data-id="element-160" data-mp="vtgkk89fj7hn">
      <Doodle kind="leaf" className="absolute -left-2 top-10 hidden h-12 w-12 rotate-12 lg:block" data-id="element-161" data-mp="14vg2d2s9qfln" />
      <Doodle kind="heart" className="absolute right-10 top-12 hidden h-6 w-6 rotate-12 lg:block" data-id="element-162" data-mp="zwd2dwr5azkj" />
      <Container data-id="element-163" data-mp="2c4wmyl7pu6ft">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-164" data-mp="2c5g62593r0vf">
          <div data-id="element-165" data-mp="2h3rcs743ov9f">
            <h2 id="final-title" className="text-balance font-heading text-[2.2rem] font-black leading-[1.05] tracking-[-0.015em] text-white sm:text-[2.8rem] lg:text-[3.3rem]" data-id="element-166" data-mp="2h37xky5u4kz3">
              Una decisión menos <span className="text-sun" data-id="element-167" data-mp="2r3i9mfg4vmco">cada noche.</span>
            </h2>
            <p className="mt-5 text-base leading-relaxed text-white/90 sm:text-lg" data-id="element-168" data-mp="2v2hddwq4pd2j">
              Mañana no tenés que volver a empezar de cero. Empezá con un sistema y tené una respuesta cuando vuelva a aparecer la pregunta:
            </p>
            <p className="mt-4 font-heading text-xl font-extrabold text-sun sm:text-2xl" data-id="element-169" data-mp="34vezsdy8rm6f">“¿Qué preparo para mañana?”</p>
            <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-170" data-mp="3eri2bkx09mtw">
              {finalSummary.map(({
              icon: Icon,
              title
            }) => <li key={title} className="flex items-center gap-3 text-base font-medium text-white" data-id="element-171" data-mp="3islcprwaaqnq">
                  <Icon aria-hidden="true" className="h-5 w-5 shrink-0 text-teal-light" data-id="element-172" data-mp="1jnk104omporl" />
                  {title}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[1.75rem] bg-white/[0.07] p-4 ring-1 ring-white/15 sm:p-8" data-id="element-173" data-mp="1sgeyudbroi7c">
            {launchActive && <div className="mb-7" data-id="element-174" data-mp="1novr0bbf0c0b">
                <p className="mb-3 flex items-center justify-center gap-2 font-display text-sm font-extrabold uppercase tracking-[0.1em] text-white" data-id="element-175" data-mp="1nnu5fcwrw74c">
                  <TimerIcon aria-hidden="true" className="h-5 w-5 text-sun" data-id="element-176" data-mp="1xgjha8w8jn07" />
                  El precio cierra en:
                </p>
                <CountdownUnits countdown={countdown} tone="dark" data-id="element-177" data-mp="2beq2aog35sig" />
              </div>}
            <ProductMockup tone="dark" decorated={false} className="mx-auto max-w-[400px]" data-id="element-178" data-mp="27epc66jmjsvk" />
            <div className="mt-8 text-center" data-id="element-179" data-mp="h1rx2j98tm1z">
              {regularPrice && <p className="text-lg font-semibold text-white/70 line-through decoration-pink decoration-2" data-id="element-180" data-mp="d0oj62ara03e">{regularPrice}</p>}
              <p className="font-heading text-5xl font-black tracking-tight text-sun" data-id="element-181" data-mp="2whsiuahym48">{price}</p>
              <p className="mt-2 text-sm text-white sm:text-base" data-id="element-182" data-mp="6x1r82apxxsh">Pago único · Sin suscripciones</p>
            </div>
            <CTAButton label="Quiero resolver las viandas" location="cta-final" fullWidth className="mt-6" data-id="element-183" data-mp="3p9gd53kzemdw" />
            <p className="mt-4 text-center text-sm font-medium text-teal-light" data-id="element-184" data-mp="3u8atlyvh7yuu">{trust.join(' · ')}</p>
          </div>
        </div>
      </Container>
    </section>;
}